import { isInstanceSuperAdmin, isSuperAdmin } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

/** Check whether the current user has access to the all content page in the back-office
 * To has access those conditions should be met:
 * - User is global or site admin
 */
const isContentBulkAllowed = createSelector(isSuperAdmin, isInstanceSuperAdmin, (isGlobalAdmin, isSiteAdmin) => {
    return isGlobalAdmin || isSiteAdmin;
});

export { isContentBulkAllowed };
